import { useQuery } from 'react-query';
import { ProjectId } from 'api/models';
import { ProjectAPI } from 'api/project';
import {
  getProjectSprintsQueryKey,
  getSprintsForProject,
} from 'queries/common';

export const useSprints = (
  projectId: ProjectId,
  options?: {
    refetchOnMount: boolean;
  },
) => {
  return useQuery(
    getProjectSprintsQueryKey(projectId),
    () => ProjectAPI.getSprints(projectId[1]),
    {
      retry: 1,
      retryOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      enabled: typeof projectId?.[1] === 'number',
      cacheTime: 0,
      ...options,
    },
  );
};

export const useSprintsOptionsForProject = (
  projectId: ProjectId,
  options?: {
    refetchOnMount: boolean;
  },
) => {
  return useQuery(
    getSprintsForProject(projectId),
    () => ProjectAPI.getSprintsForProject(projectId[1]),
    {
      retry: 1,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      enabled: typeof projectId?.[1] === 'number',
      ...options,
    },
  );
};
